export default {
	namespaced: true,

	/**
	 * struttura elemento dentro question:
	 * {
	 *     id: id domanda(nodo)
	 *     value: valore risposta
	 *     question: oggetto originale della domanda (vedi costruzione domande)
	 * }
	 *
	 * */

	state: {
		questions: [],
		variables: [],
		refreshable: 0,
		progressPercentage: 0,
		progressColor: "#409EFF",
		loaded: false,
		owners: {},
		is_compilation_running: false
	},
	getters: {
		questions: state => state.questions,
		variables: state => state.variables,
		progressPercentage: state => state.progressPercentage,
		progressColor: state => state.progressColor,
		selected: state => id => {
			return state.questions.find(x => x.id == id)
		},
		selected_value: state => id => {
			return state.questions.find(x => x.id === id) !== undefined
				? state.questions.find(x => x.id === id).value
				: null
		},
		refreshable: state => state.refreshable,
		owners: state => state.owners,
		is_compilation_running: state => state.is_compilation_running
	},
	mutations: {
		/* editor */

		SET_QUESTIONS(state, val) {
			state.questions = val
		},
		SET_VARIABLES(state, val) {
			state.variables = val
		},
		SET_OWNERS(state, payload) {
			state.owners = payload
		},
		SET_COMPILATION(state, payload) {
			state.is_compilation_running = payload
		},

		REFRESH(state) {
			state.refreshable++
		},
		DELETE_QUESTIONS(state) {
			state.questions = []
		},
		DELETE_VARIABLES(state) {
			state.variables = undefined
		},
		CHANGE_VALUE(state, payload) {
			let tmp = state.questions.find(x => x.id == payload.id)
			let indx = state.questions.findIndex(x => x.id == payload.id)
			tmp.value = payload.value
			state.questions[indx] = tmp
		},
		SET_PERCENTAGE(state, payload) {
			state.progressPercentage = payload
			state.progressPercentage === 100 ? (state.progressColor = "#67C23A") : (state.progressColor = "#409EFF")
		},

		CLEAR_STATE(state) {
			state.questions = []
			state.variables = []
			state.refreshable = 0
			state.progressPercentage = 0
			state.progressColor = "#409EFF"
			state.loaded = false
			state.owners = {}
		}
	},
	actions: {
		async addQuestions({ state, commit, dispatch }, array) {
			commit("DELETE_QUESTIONS")
			commit("SET_QUESTIONS", array)
			return true
		},
		async addVariables({ state, commit, dispatch }, array) {
			commit("DELETE_VARIABLES")
			commit("SET_VARIABLES", array)
			return true
		},
		async updateValue({ state, commit, dispatch }, payload) {
			commit("CHANGE_VALUE", payload)
			return true
		},
		connectQuestionVar({ state, commit, dispatch }) {
			state.questions.forEach(quest => {
				if (typeof quest.question.value === "object") {
					var variablesss = state.variables.filter(function (va) {
						return va.node.id == quest.question.value.index
					})
					variablesss.forEach(variable => {
						variable.isqst = true

						if (variable.node_value) {
							if (typeof variable.node_value === "object") {
								//TODO necessario?
								dispatch("setValue", {
									element: quest,
									val: variable.node_value.value
								})
							} else {
								dispatch("updateValue", {
									id: quest.id,
									value: variable.node_value
								})
							}
						}
					})
				}
			})
		},

		async setValue({ state, commit, dispatch }, { element, val }) {
			var opt = undefined

			switch (true) {
				case element.question.value.type === "choice":
					let indxSpec = element.question.map.findIndex(e => {
						return e.value.includes(val)
					})

					if (val && indxSpec != -1) {
						opt = element.question.map[indxSpec].ref
					}
					break
				case element.question.value.type === "number":
					element.question.map.forEach(el => {
						if (el.ref !== undefined) {
							if (typeof el.value !== "number") {
								return false
							}
							if (typeof el.sign.length === "Array") {
								return false
							}

							if (el.sign === "=") {
								el.sign = "=="
							}

							val = val ? val : 0
							if (new Function("return " + val + el.sign + el.value)()) {
								opt = el.ref
							}
						}
					})
					break
				case element.question.value.type === "date":
					var compiledvalue = val.split("/")
					compiledvalue = new Date(compiledvalue[2], compiledvalue[1] - 1, compiledvalue[0])

					element.question.map.forEach(el => {
						if (el.ref !== undefined) {
							if (typeof el.sign.length === "Array") {
								return false
							}

							var mapvalue = el.value.split("/")
							mapvalue = new Date(mapvalue[2], mapvalue[1] - 1, mapvalue[0])
							if (el.sign === "=") {
								el.sign = "=="
							}

							if (new Function("return " + compiledvalue.getTime() + el.sign + mapvalue.getTime())()) {
								opt = el.ref
							}
						}
					})
					break
				case element.question.value.type === "image":
					if (val) {
						opt = element.question.map[0].ref
					} else {
						opt = element.question.map[1].ref
					}
					break
				case element.question.value.type === "text" || element.question.value.type === "long-text":
					if (element.question.map.length >= 3) {
						var found = false
						for (let i = 2; i < element.question.map.length; i++) {
							if (val.includes(element.question.map[i].special_contains_value)) {
								opt = element.question.map[i].ref
								found = true
							}
						}
						if (!found) {
							if (val) {
								opt = element.question.map[0].ref
							} else {
								opt = element.question.map[1].ref
							}
						}
					} else {
						if (val) {
							opt = element.question.map[0].ref
						} else {
							opt = element.question.map[1].ref
						}
					}

					break
				default:
					if (val) {
						opt = val
					}
			}

			await dispatch("updateValue", { id: element.id, value: opt })

			//	await this.autoCompile()
			// this.refresh()
		}
	}
}
